<div class="ml-auto d-flex  align-items-end justify-content-end container-button" [ngClass]="{'my-3' : !buttonDisabled}" id="continue-itinerary-s" style="gap: .5em;">

  <button type="button"
          class="btn rounded btn-block btn-big font-poppins btn-resize-return"
          style="border: 1px solid #b2b2b2;"
          [ngStyle]="{'width': !buttonDisabled ? '75%' : '100%'}"
          (click)="_redirectHome()"
      >
          <i class="{{_findData?'fa fa-spinner fa-spin fa-sm':''}}"></i>
          Regresar
</button>
  <button *ngIf="!buttonDisabled"
          type="button"
          class="btn rounded btn-block btn-usblick btn-big font-poppins"
          (click)="_redirectToResults(modeView)"
          [disabled]="buttonDisabled"
          [ngStyle]="{
            'color': styleSidebar?.color,
            'background-color': buttonDisabled ? 'lightgray': getClientsSettingAppBooking?.clients_setting_global?.color_main_3 }"
          >
          <i class="{{_findData?'fa fa-spinner fa-spin fa-sm':''}}"></i>
          Continuar
  </button>
</div>
